import { IS_JEST, IS_PRODUCTION } from 'shared/consts'

export default (): boolean => !IS_JEST && !IS_PRODUCTION
